"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RuleFactory = void 0;
const index_1 = require("./index");
const SimpleRulePack_1 = require("./SimpleRulePack");
class RuleFactory {
    static create(config) {
        const factory = RuleFactory.RULES[config.type];
        if (factory) {
            return factory(config);
        }
        throw {
            message: `Can't find any rule of type ${config.type}`,
        };
    }
    static register(ruletype, factory) {
        RuleFactory.RULES[ruletype] = factory;
    }
}
exports.RuleFactory = RuleFactory;
RuleFactory.RULES = {
    ...index_1.RULE_DICTIONARY,
    ...SimpleRulePack_1.PACK,
};
//# sourceMappingURL=RuleFactory.js.map